/*
Format pricing from number properly (received from vlux)
Example: 123.1 => 123.10 €
 */
export const formatPrice = (priceInVlux: string) => {
    const priceStr = (priceInVlux + "").split('.');
    const euro = priceStr[0];
    const cents = (!(priceStr[1]) && "00") || (priceStr[1] && priceStr[1].length < 2 && priceStr[1] + "0") || (priceStr[1]);
    const currency = "€";
    return { euro, cents, currency };
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/utils/price-utils.ts